import { apiClient, ApiName } from '@shared/services/api'

export const checkEmailStatus = (email) => {
  return apiClient.get(ApiName.LOGIN, `status/${email}`)
}

export const login = (data) => {
  return apiClient.post(ApiName.LOGIN, '', data)
}

export const recoverPassword = (data) => {
  return apiClient.post(ApiName.LOGIN, 'passwords/recover', data)
}

export const resetPassword = (data) => {
  return apiClient.patch(ApiName.LOGIN, 'passwords', data)
}
